import $ from 'jquery'
import { onConnect } from '@sonicgarden/onconnect'

onConnect('[data-toggle="tooltip"]', (el) => {
  $(el).tooltip()

  return () => {
    $(el).tooltip('dispose')
  }
})
